import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'
import { faCircleCheck as normalCircleCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'
import { useStyles } from './StepStatusIcon.styles'

export type StatusIconType = 'completed' | 'standBy' | 'error'

export function getSectionStatus(
  sectionCompleted: boolean,
  doesSectionHaveErrors: boolean
): StatusIconType {
  if (doesSectionHaveErrors) {
    return 'error'
  } else if (sectionCompleted) {
    return 'completed'
  } else {
    return 'standBy'
  }
}

export const StatusIcon: React.FC<{ status: StatusIconType }> = ({
  status,
}) => {
  const { classes } = useStyles()
  switch (status) {
    case 'completed':
      return (
        <FontAwesomeIcon
          data-testid="step-icon"
          icon={normalCircleCheck}
          className={clsx(classes.loader, classes.check)}
        />
      )
    case 'error':
      return (
        <FontAwesomeIcon
          data-testid="step-icon"
          icon={faCircleXmark}
          className={clsx(classes.loader, classes.cross)}
        />
      )
    case 'standBy':
      return (
        <FontAwesomeIcon
          data-testid="step-icon"
          icon={normalCircleCheck}
          className={clsx(classes.loader, classes.normal)}
        />
      )
    default:
      return null
  }
}
